import { Image as ExpoImage, type ImageProps, type ImageSource } from "@-/com.npmjs.expo-image";
import { withUniwind } from "@-/com.npmjs.uniwind";
import { resolveImageSource } from "#resolve-image-source";

type ExpoImageRef = React.ElementRef<typeof ExpoImage>;

// expo-image's native component doesn't understand `className` on its own, so wrap it with
// `withUniwind` to translate Tailwind classes into styles. Without this, a `className`-only sized
// image (e.g. `size-full`) resolves to no dimensions and lays out at 0×0 — the image never loads
// (no `onLoad`/`onError`) and renders as a blank box.
const UniwindExpoImage = withUniwind(ExpoImage);

export function Image({
  placeholder,
  source,
  ...props
}: ImageProps & React.RefAttributes<ExpoImageRef>) {
  return (
    <UniwindExpoImage
      placeholder={resolveImageSource(placeholder)}
      source={resolveImageSource(source)}
      {...props}
    />
  );
}

export type { ImageProps, ImageSource };
